import { Injectable } from '@angular/core';
import { LoadingController, Events } from 'ionic-angular';

@Injectable()
export class LoadingService {

  public customText: string;

  constructor(
    public loadingCtrl: LoadingController,
    public events: Events
  ) {
  }

  start(customText?: string) {
    if (customText) {
      this.customText = customText;
    }
    this.events.publish('loading', {state: true, customText: this.customText});
  }

  end() {
    setTimeout(() => {
      this.events.publish('loading', {state: false});
      this.customText = null;
    }, 200);
  }

}



// WEBPACK FOOTER //
// ./src/shared/services/loading.service.ts